import { Stack } from '@mui/material';
import IncPageBody from 'components/inc-page/inc-page-body/inc-page-body.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import { useSMSTotalsSearch } from '../../sms-reports-landing/sms-reports-search/sms-reports-search.hooks';
import AccountVerificationContent from './account-verification-content/account-verification-content.component';
import AccountVerificationSummaryHeader from './account-verification-summary-header/account-verification-summary-header.component';

const AccountVerification = () => {
  const { refetchSMSTotals } = useSMSTotalsSearch('ACCOUNT_VERIFICATION');

  return (
    <IncPageBody>
      <SearchToolbar
        excludedFilters={['storeIds']}
        onRefreshClick={refetchSMSTotals}
      />
      <Stack mt={2} spacing={2}>
        <AccountVerificationSummaryHeader />
        <AccountVerificationContent />
      </Stack>
    </IncPageBody>
  );
};

export default AccountVerification;
